"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoContract = void 0;
const core_1 = require("@ts-rest/core");
const promo_admin_contract_1 = require("./promo.admin.contract");
const promo_auth_contract_1 = require("./promo.auth.contract");
const promo_public_contract_1 = require("./promo.public.contract");
const c = (0, core_1.initContract)();
exports.promoContract = c.router({
    admin: promo_admin_contract_1.adminPromoContract,
    public: promo_public_contract_1.publicPromoContract,
    auth: promo_auth_contract_1.authPromoContract,
}, {
    pathPrefix: '/promo',
    strictStatusCodes: true,
    jsonQuery: true,
});
__exportStar(require("./models"), exports);
__exportStar(require("./promo.admin.contract"), exports);
__exportStar(require("./promo.auth.contract"), exports);
__exportStar(require("./promo.public.contract"), exports);
//# sourceMappingURL=index.js.map